import { useStore } from '../store';
import { TwitchExtensionInitializationError } from '../types/errors';

import { useApplyVoice } from './useApplyVoice';
import { useTwitchConfiguration } from './useTwitchConfiguration';

interface UseTwitchExtListeners {
	registerTwitchExtListeners: () => void;
}

export const useTwitchExtListeners = (): UseTwitchExtListeners => {
	const { handleTransactionCancelled, handleTransactionComplete } =
		useApplyVoice();

	const store = useStore();

	const {
		handleAuthorizationReceived,
		handleBroadcastMessage,
		handleOnChangedConfiguration,
	} = useTwitchConfiguration();

	const registerTwitchExtListeners = () => {
		if (!window.Twitch?.ext) {
			const error = TwitchExtensionInitializationError.report({
				description: 'Twitch extension not found',
			});
			error.debug();
			store.showError(error);

			return;
		}

		window.Twitch.ext.onAuthorized(handleAuthorizationReceived);
		window.Twitch.ext.listen('broadcast', handleBroadcastMessage);
		window.Twitch.ext.configuration.onChanged(handleOnChangedConfiguration);

		window.Twitch.ext.bits.onTransactionCancelled(handleTransactionCancelled);
		window.Twitch.ext.bits.onTransactionComplete(handleTransactionComplete);
	};

	return {
		registerTwitchExtListeners,
	};
};
